import React, { useEffect, useState } from "react";
import {
  Page,
  Button,
  ButtonGroup,
  InlineStack,
  Divider,
  Card,
  FormLayout,
  Spinner,
  Tabs,
  Box,
  Text,
  BlockStack,
  Modal,
  Select,
  TextField,
  Banner,
  InlineError,
} from "@shopify/polaris";
import {
  CategoriesIcon,
  ClockIcon,
  EditIcon,
  ListBulletedIcon,
  PlusCircleIcon,
} from "@shopify/polaris-icons";
import ListView from "../../Components/TaskManager/ListView";
import { useParams, useNavigate } from "react-router-dom";
import axios from "../../Assets/Lib/axios";
import { capitalizeFirstLetter } from "../../Helpers";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import KanbanView from "../../Components/TaskManager/KanbanView";
import { MultiSelect } from "react-multi-select-component";
import ReactSelect from "react-select";

export default function TaskManagerMain() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeView, setActiveView] = useState("list"); // "list" | "timeline"
  const [bulkModalOpen, setBulkModalOpen] = useState(false);
  const [bulkInput, setBulkInput] = useState("");
  const [parsedBulk, setParsedBulk] = useState([]);

  const parseBulkNow = () => {
    const lines = (bulkInput || "")
      .split("\n")
      .map((l) => l.trim())
      .filter(Boolean);
    setParsedBulk(
      lines.map((title) => ({ title, assignees: [], category: "" }))
    );
  };

  // const confirmBulkAdd = () => {
  //   const baseOrder = tasks.length;
  //   const toAdd = parsedBulk.map((p, idx) => ({
  //     id: String(Date.now() + idx),
  //     title: p.title,
  //     assignees: p.assignees || [],
  //     category_id: p.category || null, // ✅ include selected category
  //   }));

  //   setTasks((prev) => [...prev, ...toAdd]);
  //   setParsedBulk([]);
  //   setBulkInput("");
  //   setBulkModalOpen(false);
  // };

  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState("");
  const confirmBulkAdd = async () => {
    if (!parsedBulk.length) return;

    setIsSaving(true);
    try {
      // Prepare the payload
      const tasksToSend = parsedBulk.map((p) => ({
        title: p.title,
        category_id: p.category || null,
        assignee_ids: (p.assignees || []).map((a) => a.value),
        task_manager_project_id: id,
        status_id: statusFilter,
        country: "All",
      }));

      // Call API
      await axios.post("/task-managers/multiple", { tasks: tasksToSend });

      // Optionally refresh tasks
      await fetchTasks();
      await refreshStatuses();

      // Reset UI
      setParsedBulk([]);
      setBulkInput("");
      setBulkModalOpen(false);
    } catch (err) {
      console.error("❌ Failed to bulk add tasks:", err);
      console.error("errorrr=", err.response.data.message);
      setError(err.response.data.message || "Something went wrong, try again.");
    }
    setIsSaving(false);
  };

  const [country, setCountry] = useState("");
  const [countryButtons, setCountryButtons] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [selected, setSelected] = useState(0);
  const [statusFilter, setStatusFilter] = useState(null);
  const [result, setResult] = useState({});
  const [isReady, setIsReady] = useState(false); // full-page spinner only once
  const [didInit, setDidInit] = useState(false);
  const [isDataLoading, setIsDataLoading] = useState(false); // small loader for refetches
  const [peopleOptions, setPeopleOptions] = useState([]);
  const [categories, setCategories] = useState([]);
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(id || null);

  useEffect(() => {
    axios
      .get("/task-manager-projects")
      .then((res) => {
        const list = res?.data?.data?.data || [];
        setProjects(
          list.map((p) => ({
            id: String(p.id),
            title: p.title,
          }))
        );
      })
      .catch((err) => console.error("❌ Failed to fetch projects:", err));
  }, []);

  useEffect(() => {
    axios
      .get(`/task-manager-projects/${id}/categories`)
      .then((res) => {
        const data = res?.data?.data?.data || [];
        setCategories(
          data.map((c) => ({
            label: c.title,
            value: String(c.id),
          }))
        );
      })
      .catch((err) => console.error("❌ Failed to fetch categories:", err));
  }, []);
  // ✅ Fetch people from API
  useEffect(() => {
    axios
      .get("/people?all")
      .then((res) => {
        const data = res?.data?.data || [];
        setPeopleOptions(
          data.map((p) => ({
            label: p.name,
            value: String(p.id),
          }))
        );
      })
      .catch((err) => console.error("❌ Failed to fetch assignees:", err));
  }, []);

  // ✅ Restore session tab
  useEffect(() => {
    const savedIndex = sessionStorage.getItem(`task_selected_index_${id}`);
    const savedStatus = sessionStorage.getItem(`task_status_${id}`);
    if (savedIndex !== null) setSelected(Number(savedIndex));
    if (savedStatus) setStatusFilter(Number(savedStatus));
  }, [id]);

  // ✅ Fetch countries
  useEffect(() => {
    axios
      .get("/settings/countries")
      .then((res) => {
        const countriesData = res?.data?.data || [];
        const options = [
          { label: "All", value: "" },
          { label: "Mutual", value: "All" },
          ...countriesData.map((country) => ({
            label: country.name,
            value: country.name,
            flag: country.flag,
          })),
        ];
        setCountryButtons(options);
      })
      .catch((err) => console.log(err));
  }, []);

  // ✅ Fetch statuses first
  useEffect(() => {
    axios
      .get(`task-manager-projects/${id}/statuses`)
      .then((res) => {
        const data = res.data.data.data || [];
        setStatuses(data);

        if (data.length > 0) {
          const savedStatus = sessionStorage.getItem(`task_status_${id}`);
          const savedIndex = sessionStorage.getItem(
            `task_selected_index_${id}`
          );

          if (savedStatus && savedIndex !== null) {
            setSelected(Number(savedIndex));
            setStatusFilter(savedStatus);
          } else {
            setStatusFilter(data[0].id);
            setSelected(0);
          }
        } else {
          setIsReady(true);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setDidInit(true));
  }, [id]);

  const refreshStatuses = async () => {
    try {
      const res = await axios.get(`task-manager-projects/${id}/statuses`);
      const data = res.data.data.data || [];
      setStatuses(data);
    } catch (err) {
      console.error("❌ Failed to refresh statuses:", err);
    }
  };

  // ✅ Fetch tasks when filters, view or statuses change
  useEffect(() => {
    if (!didInit) return;
    if (activeView === "list" && !statusFilter) return;

    let isMounted = true;
    const isFirstLoad = !didInit && Object.keys(result).length === 0;

    const fetchData = async () => {
      if (isFirstLoad) setIsReady(false);
      else setIsDataLoading(true);

      try {
        const params = new URLSearchParams();

        // 🔹 Only filter by status in List view
        if (activeView === "list" && statusFilter) {
          params.append("filter[status_id]", statusFilter);
        }

        if (country) params.append("filter[country]", country);
        params.append("filter[task_manager_project_id]", id);

        const { data: res } = await axios.get("/task-manager", { params });
        const rawTasks = res?.data?.data || [];

        // 🔹 Group differently based on the active view
        const grouped = rawTasks.reduce((acc, task) => {
          const groupKey =
            activeView === "kanban"
              ? task?.status?.name || "Uncategorized"
              : task?.category?.title || "Uncategorized";

          if (!acc[groupKey]) acc[groupKey] = [];

          acc[groupKey].push({
            id: task.id,
            title: task.title,
            category: task.category,
            description: task.description,
            screenshots: task.screenshots || [],
            screenshots_keys: task.screenshots_keys || [],
            country: task.country || "",
            is_high: task.is_high || "0",
            assignees:
              task.assignees?.map((item) => ({
                name: item.name,
                image_url: item.image_url,
                id: item.id,
              })) || [],
            reporters:
              task.reporters?.map((item) => ({
                name: item.name,
                image_url: item.image_url,
                id: item.id,
              })) || [],
            score: task.order || 0,
            status: { id: String(task.status?.id), name: task.status?.name },
            country: task.country,
            deadline: task.deadline,
          });

          return acc;
        }, {});

        if (isMounted) {
          setResult(grouped);
          setIsReady(true);
          setIsDataLoading(false);
        }
      } catch (error) {
        console.error("❌ Error fetching tasks:", error);
        if (isMounted) {
          setIsReady(true);
          setIsDataLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [country, statusFilter, activeView, didInit]);
  const fetchTasks = async () => {
    try {
      const params = new URLSearchParams();
      if (activeView === "list" && statusFilter)
        params.append("filter[status_id]", statusFilter);
      if (country) params.append("filter[country]", country);
      params.append("filter[task_manager_project_id]", id);

      const { data: res } = await axios.get("/task-manager", { params });
      const rawTasks = res?.data?.data || [];

      const grouped = rawTasks.reduce((acc, task) => {
        const groupKey =
          activeView === "kanban"
            ? task?.status?.name || "Uncategorized"
            : task?.category?.title || "Uncategorized";
        if (!acc[groupKey]) acc[groupKey] = [];
        acc[groupKey].push(task);
        return acc;
      }, {});

      setResult(grouped);
    } catch (err) {
      console.error("Error refetching tasks:", err);
    }
  };
  // ✅ Full-page spinner (only on very first load)
  if (!isReady) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spinner size="large" />
      </div>
    );
  }

  // ✅ Tabs
  const tabs = statuses.map((status) => ({
    id: `${status.id}`,
    content: (
      <span style={{ color: "#6a788c" }}>
        {capitalizeFirstLetter(status.name)} ({status.tasks_count || 0})
      </span>
    ),
    panelID: `status-content-${status.id}`,
  }));

  return (
    <Page
      title="Task Manager"
      fullWidth
      // backAction={{ onAction: () => navigate("/admin/task-manager/projects") }}
      primaryAction={
        <ButtonGroup>
          <Button
            variant="primary"
            onClick={() => setBulkModalOpen(true)}
            icon={PlusCircleIcon}
          >
            Bulk Tasks
          </Button>
          <Button
            variant="primary"
            onClick={() =>
              navigate(
                `/admin/task-manager/projects/${id}/tasks/new?${
                  statusFilter ? `status=${statusFilter}` : ""
                }`
              )
            }
            icon={PlusCircleIcon}
          >
            Add Task
          </Button>
        </ButtonGroup>
      }
    >
      <FormLayout>
        {/* Country Buttons */}

        <Card>
          <BlockStack gap="500">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center", // ✅ keeps both sides aligned vertically
                flexWrap: "wrap",
                gap: "1rem",
                rowGap: "1.5rem",
              }}
            >
              {projects.length > 0 && (
                <div style={{ overflowX: "auto", paddingBottom: "0.5rem" }}>
                  <InlineStack gap="300" wrap align="center">
                    <ButtonGroup segmented>
                      {projects.map((project) => (
                        <Button
                          key={project.id}
                          pressed={
                            String(selectedProject) === String(project.id)
                          }
                          onClick={() => {
                            Object.keys(sessionStorage).forEach((key) => {
                              if (
                                key.startsWith("task_selected_index_") ||
                                key.startsWith("task_status_")
                              ) {
                                sessionStorage.removeItem(key);
                              }
                            });
                            setSelectedProject(project.id);
                            navigate(
                              `/admin/task-manager/projects/${project.id}/tasks`
                            );
                          }}
                        >
                          {project.title}
                        </Button>
                      ))}
                      <Button
                        icon={EditIcon}
                        // variant="primary"
                        onClick={() =>
                          navigate(`/admin/task-manager/projects-list`)
                        }
                      ></Button>
                    </ButtonGroup>
                  </InlineStack>
                </div>
              )}
              {/* 🔹 Left side: Filters + Timeline buttons */}
              <InlineStack gap="300" wrap align="center">
                {/* <ButtonGroup segmented>
                  {countryButtons.map((t) => (
                    <Button
                      key={t.value}
                      pressed={country === t.value}
                      onClick={() => setCountry(String(t.value))}
                    >
                      {t.flag && (
                        <img
                          src={t.flag}
                          alt={t.flag}
                          style={{ width: 20, marginRight: 6 }}
                        />
                      )}
                      {t.label}
                    </Button>
                  ))}
                </ButtonGroup> */}
              </InlineStack>

              {/* 🔹 Right side: Country buttons */}
              <Box display="flex" alignItems="center">
                <InlineStack direction={"row"} gap={400}>
                  <ButtonGroup segmented>
                    <Button
                      pressed={activeView === "list"}
                      icon={ListBulletedIcon}
                      onClick={() => setActiveView("list")}
                    >
                      List
                    </Button>
                    <Button
                      pressed={activeView === "kanban"}
                      icon={CategoriesIcon}
                      onClick={() => setActiveView("kanban")}
                    >
                      Kanban
                    </Button>
                  </ButtonGroup>
                  <ButtonGroup segmented>
                    {countryButtons.map((t) => (
                      <Button
                        key={t.value}
                        pressed={country === t.value}
                        onClick={() => setCountry(String(t.value))}
                      >
                        {t.flag && (
                          <img
                            src={t.flag}
                            alt={t.flag}
                            style={{ width: 20, marginRight: 6 }}
                          />
                        )}
                        {t.label}
                      </Button>
                    ))}
                  </ButtonGroup>
                </InlineStack>
              </Box>
            </div>
          </BlockStack>
        </Card>

        <Divider />

        {statuses.length === 0 ? (
          <Card>
            <div style={{ textAlign: "center", padding: "2rem" }}>
              <img
                src={emptyListImage}
                style={{ width: "25%", marginBottom: 16 }}
                alt="No statuses"
              />
              <Text variant="headingLg" as="h5" color="subdued">
                No statuses found
              </Text>
            </div>
          </Card>
        ) : activeView === "list" ? (
          <div className="mb-3">
            <Tabs
              fitted
              tabs={tabs}
              selected={selected}
              onSelect={(index) => {
                setSelected(index);
                sessionStorage.setItem(`task_selected_index_${id}`, index);
                const selectedStatus = statuses[index];
                if (selectedStatus) {
                  const newStatusId = Number(selectedStatus.id);
                  setStatusFilter(newStatusId);
                  sessionStorage.setItem(`task_status_${id}`, newStatusId);
                }
                setResult({});
              }}
            >
              {!isDataLoading && Object.entries(result).length ? (
                <ListView
                  rows={result}
                  statuses={statuses.map(({ id, name }) => ({ id, name }))}
                  onRefresh={() => {
                    fetchTasks();
                    refreshStatuses(); // 🟢 refresh counts after move
                  }}
                />
              ) : isDataLoading ? (
                <div style={{ textAlign: "center", padding: "2rem" }}>
                  <Spinner size="small" />
                </div>
              ) : (
                <Card>
                  <div style={{ textAlign: "center", padding: "2rem" }}>
                    <img
                      src={emptyListImage}
                      style={{ width: "25%", marginBottom: 16 }}
                      alt="No results"
                    />
                    <Text as="p" fontWeight="regular" tone="subdued">
                      No results found
                    </Text>
                  </div>
                </Card>
              )}
            </Tabs>
          </div>
        ) : (
          <KanbanView
            rows={result}
            statuses={statuses.map(({ id, name }) => ({ id, name }))}
            onRefresh={() => {
              fetchTasks();
              refreshStatuses(); // 🟢 refresh counts after move
            }}
          />
        )}
      </FormLayout>

      <Modal
        size="large"
        open={bulkModalOpen}
        onClose={() => {
          setBulkModalOpen(false);
          setBulkInput(""); // 🧹 clear textarea
          setParsedBulk([]); // 🧹 clear parsed tasks
        }}
        title="Add tasks in bulk"
        primaryAction={{
          content: parsedBulk.length
            ? `Add ${parsedBulk.length} task(s)`
            : "Parse",
          onAction: parsedBulk.length ? confirmBulkAdd : parseBulkNow,
          disabled: !bulkInput.trim() && !parsedBulk.length,
          loading: isSaving,
        }}
        secondaryActions={[
          parsedBulk.length
            ? {
                content: "Back",
                onAction: () => setParsedBulk([]),
              }
            : {
                content: "Cancel",
                onAction: () => {
                  setBulkModalOpen(false);
                  setBulkInput(""); // 🧹 also clear on Cancel
                  setParsedBulk([]);
                },
              },
        ]}
      >
        <Modal.Section>
          <FormLayout>
            {!parsedBulk.length ? (
              <BlockStack gap="300">
                <TextField
                  label="Tasks (one per line)"
                  value={bulkInput}
                  onChange={setBulkInput}
                  multiline={10}
                  autoComplete="off"
                  placeholder={"Task 1\nTask 2\nTask 3"}
                />
                <Text tone="subdued" as="p">
                  Paste or type each task on a new line. Press <b>Parse</b> to
                  review before adding.
                </Text>
              </BlockStack>
            ) : (
              <BlockStack gap="200">
                {/* <Banner>
                  Assign people to each parsed task (default: Sarah Chen).
                </Banner> */}
                {/* ✅ Scrollable table container */}
                <div
                  style={{
                    overflowX: "auto", // single horizontal scroll
                    whiteSpace: "nowrap",
                    paddingBottom: "8px",
                  }}
                >
                  {/* ✅ Table header (optional but clean) */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontWeight: "bold",
                      color: "#637381",
                      marginBottom: "6px",
                      minWidth: "900px", // ensure scroll width if needed
                    }}
                  >
                    <div style={{ width: "350px" }}>Title</div>
                    <div style={{ width: "200px" }}>Category</div>
                    <div style={{ width: "260px" }}>Assignees</div>
                    <div style={{ width: "120px" }}>Action</div>
                  </div>

                  {/* ✅ Table body */}
                  {parsedBulk.map((p, idx) => (
                    <div
                      key={idx}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        minWidth: "900px", // same as header
                        marginBottom: "8px",
                      }}
                    >
                      {/* 🔹 Full title (visible, no truncation) */}
                      <div style={{ width: "350px", overflow: "hidden" }}>
                        <Text as="p" style={{ whiteSpace: "nowrap" }}>
                          {p.title}
                        </Text>
                      </div>

                      {/* 🔹 Category dropdown */}
                      <div style={{ width: "200px", flexShrink: 0 }}>
                        <Select
                          labelHidden
                          label="Category"
                          options={[
                            { label: "Select category", value: "" },
                            ...categories,
                          ]}
                          value={p.category}
                          onChange={(value) =>
                            setParsedBulk((prev) => {
                              const copy = [...prev];
                              copy[idx] = { ...copy[idx], category: value };
                              return copy;
                            })
                          }
                        />
                      </div>

                      {/* 🔹 MultiSelect */}
                      <div
                        style={{
                          width: "260px",
                          flexShrink: 0,
                          position: "relative",
                          zIndex: 1, // Keep local z-index small; portal handles the real stacking
                        }}
                      >
                        <ReactSelect
                          isMulti
                          isSearchable
                          options={peopleOptions}
                          value={p.assignees}
                          onChange={(v) => {
                            setParsedBulk((prev) => {
                              const copy = [...prev];
                              copy[idx] = { ...copy[idx], assignees: v };
                              return copy;
                            });
                          }}
                          placeholder="Select assignees"
                          menuPortalTarget={document.body} // ✅ render menu outside modal hierarchy
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 999999 }), // ✅ always on top
                            menu: (base) => ({
                              ...base,
                              zIndex: 999999,
                              position: "absolute",
                            }),
                            control: (base) => ({
                              ...base,
                              minHeight: "36px",
                              borderColor: "#dcdcdc",
                              boxShadow: "none",
                              "&:hover": { borderColor: "#5c6ac4" },
                            }),
                          }}
                          classNamePrefix="react-select"
                        />
                      </div>

                      {/* 🔹 Remove button */}
                      <div style={{ width: "120px", flexShrink: 0 }}>
                        <Button
                          tone="critical"
                          onClick={() =>
                            setParsedBulk((prev) =>
                              prev.filter((_, i) => i !== idx)
                            )
                          }
                        >
                          Remove
                        </Button>
                      </div>
                    </div>
                  ))}
                </div>
              </BlockStack>
            )}
            <InlineError message={error} />
          </FormLayout>
        </Modal.Section>
      </Modal>
    </Page>
  );
}
